import React from 'react'
import styled, { css } from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { VoterTypes } from 'admin/pages/Voters'
import { mobileCss } from 'utils/theme'

export interface InitialVotingTableRowTypes {
  id: string
  sortingName: string
  type: string
  nominee: string
  nominatedBy: string
  nominatedByCompany: string
  tableComments?: string
}

interface InitialVotingTableProps {
  candidates: InitialVotingTableRowTypes[]
  voter?: VoterTypes
  onVote: (candidateId: string, value: boolean) => void
  votes: {
    [key: string]: {
      value: boolean
      nominee: string
    }
  }
}

const InitialVotingTable = ({ candidates, voter, onVote, votes }: InitialVotingTableProps) => {
  const voterCode = voter?.code || ''
  const navigate = useNavigate()
  const isSaved = voter?.initial_voting_saved || false

  const sortedCandidates = candidates
    .slice() // Create a copy to avoid mutating the original array
    .sort((a, b) => (a.sortingName > b.sortingName ? 1 : -1))

  return (
    <>
      {sortedCandidates.map(candidate => {
        return (
          <Wrapper key={candidate.id}>
            <CandidateName onClick={() => {
              navigate(`/preselekcja/${voterCode}/${candidate.id}`)
            }}>{candidate?.nominee || '---'}
            </CandidateName>
            <FormWrapper>
              <Option
                active={votes[candidate.id]?.value}
                onClick={() => onVote(candidate.id, true)}
                disabled={isSaved}
              >
                Tak
              </Option>
              <Option
                active={!votes[candidate.id]?.value}
                onClick={() => onVote(candidate.id, false)}
                disabled={isSaved}
              >
                Nie
              </Option>
            </FormWrapper>
          </Wrapper>
        )
      })}
    </>
  )
}

export default InitialVotingTable

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  gap: 8px;
  
  ${mobileCss(`
    flex-direction: column;
    margin-bottom: 20px;
    gap: 6px;
  `)};
`
const CandidateName = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  min-height: 46px !important;
  padding: 5px;

  font-size: 18px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  border-radius: 23px 0 0 23px;
  transition: all .3s;
  text-align: center;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryLight};
  }
  
  ${mobileCss(`
    width: 100%;
    border-radius: 8px;
  `)};
`
const FormWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  border-radius: 0 23px 23px 0;
  display: flex;
  align-items: center;
  overflow: hidden;
  height: 56px;

  ${mobileCss(`
    width: 100%;
    border-radius: 8px;
  `)};
`

const Option = styled.div<{
  active?: boolean
  disabled: boolean
}>`
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 30px;
  cursor: pointer;
  transition: all .3s;
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryLight};
  }
  
  ${({ active }) => active && css`
    background-color: ${({ theme }) => theme.colors.primary};
    color: #fff;
  `}
  
  ${({ disabled, active }) => disabled && css`
    background: ${active ? '#ccc' : '#fff'};
    pointer-events: none;
  `}
`
